import React from 'react';
import BlogComp from '../Components/BlogComp';

const Blog = () => {
    return (
        <div>
            <BlogComp></BlogComp>
        </div>
    );
};

export default Blog;